import React, { useState, useEffect } from "react";
import { Select, Form, Spin, Button } from "antd";
import { GetFetchSucursales } from "../Api/Administracion/GetFetchSucursales";
import { GetFetchEstados } from "../Api/Administracion/GetFetchEstados";
import { UseAdmin } from "../hooks";


export const FormTienda = ({ personal, setPersonal, form }) => {
  // const [form] = Form.useForm();
  const { brandfiMarcaId, branchFiSucursalId } = UseAdmin();
  const [isLoading, setIsLoading] = useState(true);
  const [optionsStore, setOptionsStore] = useState([]);
  const [optionsStates, setOptionsStates] = useState([]);
  const [stores, setStores] = useState([]);

  const handleChangeState = (value, option) => {
    setPersonal((prev) => ({
      ...prev,
      stateValue: value,
      stateText: option.label,
    }));
  };

  const handleChangeStore = (value, option) => {
    const selectedStore = stores.find((item) => item.FISUCURSALID === value);
    setPersonal((prev) => ({
      ...prev,
      storeValue: value,
      storeText: option.label,
      storeSchedule: selectedStore.FCHORARIO,
      timeValue: null,
      workerValue: null,
      workerName: null,
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const onFailure = (error) => {
        console.log(error);
        setIsLoading(false);
      };
      const onSuccess = ({ data }) => {
        const stores = data.body.data
          .filter((t) => t.FISUCURSALID !== branchFiSucursalId)
          .map((store) => ({
            value: store.FISUCURSALID,
            label: store.FCNOMBRE,
          }));
        setStores(data.body.data);
        setOptionsStore(stores);
        if (optionsStates.length === 0) {
          GetFetchEstados()
            .then((response) => {
              const states = response.data.datos.map((state) => ({
                value: state.cvegeo,
                label: state.nomgeo,
              }));
              setOptionsStates(states);
              setIsLoading(false);
            })
            .catch(onFailure);
        }
      };
      GetFetchSucursales(true, brandfiMarcaId).then(onSuccess).catch(onFailure);
    };
    if (optionsStore.length === 0 && branchFiSucursalId && brandfiMarcaId) {
      fetchData();
    }
  }, [branchFiSucursalId, brandfiMarcaId]);

  if (isLoading) return <Spin />;
  return (
    <>
      <div className={"title-store"} >
        1. Formulario Selecciones Tienda
      </div>
      <div style={{ fontSize: 16, borderBottom: "solid 1px grey", marginBottom: 15 }}>
        Para generar una nueva solicitud seleccione la tienda
      </div>

      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        initialValues={{
          state: personal?.stateValue,
          store: personal?.storeValue,
        }}
      >
        <Form.Item
          name="state"
          label="Estado"
          rules={[{ required: true, message: "Por favor seleccione un estado" }]}
        >
          <Select
            style={{ width: 120, textAlign: "left" }}
            dropdownStyle={{ textAlign: "left" }}
            onChange={handleChangeState}
            placeholder="Seleccione un estado"
            allowClear
            options={optionsStates}
          />
        </Form.Item>

        <Form.Item
          name="store"
          label="Tienda"
          rules={[{ required: true, message: "Por favor seleccione una tienda" }]}
        >
          <Select
            style={{ width: 120, textAlign: "left" }}
            dropdownStyle={{ textAlign: "left" }}
            onChange={handleChangeStore}
            placeholder="Seleccione una tienda"
            allowClear
            options={optionsStore}
          />
        </Form.Item>
      </Form>
    </>
  );
};
